export const EXP_ANALYSE_CONTENT = /^.*$/;
export function required () { return (v) => !(v === undefined || v === '' || v === null) || '此项为必填项' }
export function max (len) { return (v) => !v || v.length <= len || `长度不能超过${len}` }
export function min (len) { return (v) => !v || v.length >= len || `长度不能小于${len}` }
export function chinese () { return (v) => !v || /^[\u4e00-\u9fa5]*$/.test(v) || '只能输入中文' }
export function chineseText () { return (v) => !v || /^[a-zA-Z0-9_\u4e00-\u9fa5]*$/.test(v) || '只允许输入数字、字母、中文、下划线' }
export function chineseText2 () { return (v) => /^[a-zA-Z0-9_\u4e00-\u9fa5]*$/.test(v) }
export function normalText () { return (v) => !v || /^[a-zA-Z0-9_]*$/.test(v) || '只允许输入数字、字母、下划线' }
export function email () { return (v) => !v || /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(v) || '邮箱格式不正确' }
export function mobile () { return (v) => !v || /^(13[0-9]|14[0-9]|15[0-9]|166|167|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(v) || '手机号码格式不正确' }
export function idNo () { return (v) => !v || /^((\d{18})|([0-9x]{18})|([0-9X]{18}))$/.test(v) || '身份证号格式不正确' }
export function password () { return (v) => !v || /^[a-zA-Z0-9_]{6,12}$/.test(v) || '只能输入数字、字母、下划线,且长度在6-12之间' }
export function safePassword () { return (v) => !v || /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]){8,16}$/.test(v) || '必须由大小写字母和数字组合,长度在8-16之间' }
export function analyseContent () { return (v) => !v || EXP_ANALYSE_CONTENT.test(v) || '格式输入错误，不允许包含[\\/:：?*#!%$@]' }
export function fileName (types) {
  return (v) => { // 文件名称校验规则
    if (!v) return true;
    let typesArr = types.toLowerCase().split(',');
    return !(typesArr.indexOf(v) == -1) || `文件类型不正确,支持的文件类型[${types}]`
  }
}
export function fileType (types) {
  return (v) => { // 文件格式校验规则
    if (!v || !v.name || !types) return true;
    let parts = v.name.split('.');
    let ft = parts[parts.length - 1].toLowerCase();
    let typesArr = types.toLowerCase().split(',');
    return !(typesArr.indexOf(ft) == -1) || `文件类型不正确,支持的文件类型[${types}]`
  }
}
